import Presentation   from "./presentation";
import useSWRInfinite from "swr/infinite";
import { useRouter }  from "next/router";

import {
	getUpdatesNotificationsFeed,
	getFeaturesNotificationsFeed,
	getAnnouncementsNotificationsFeed
} from "_services/api/user";
import { useEffect }               from "react";
import { notificationQRPopupAtom } from "_jotai/notifications";
import { useAtom }                 from "jotai";

const notificationsFetcher = async params => {

	const { tabName, pageNo, SK } = params;

	if ( !tabName )
		return;

	let response = [];

	switch ( tabName ) {
		case "updates":
			response = await getUpdatesNotificationsFeed ( { pageNo, pageSize: 10, SK } );
			break;

		case "features":
			response = await getFeaturesNotificationsFeed ( { pageNo, pageSize: 10, SK } );
			break;

		case "announcements":
			response = await getAnnouncementsNotificationsFeed ( { pageNo, pageSize: 10, SK } );
			break;

		default:
			break;
	}

	return response;
};

const component = ( { activeUpdateTab, clickImpression, activeTab, viewImpression } ) => {

	const { data, error, size, setSize, mutate } = useSWRInfinite (
		( index, previousPageData ) => {
			if ( !previousPageData )
				return { key: `notification-${ activeUpdateTab }Tab`, pageNo: index + 1, tabName: activeUpdateTab };

			return { key: `notification-${ activeUpdateTab }Tab`, SK: previousPageData[previousPageData.length - 1]?.["SK"], pageNo: index + 1 };
		},
		notificationsFetcher,
		{
			revalidateFirstPage : false,
			revalidateOnFocus   : false
		}
	);

	// state for infinite call logic
	let feedData               = [].concat.apply ( [], data );
	const isLoadingInitialData = !data && !error;
	const isDataEmpty          = data?.[size - 1]?.length === 0;
	const isLoadingMoreData    = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	const [ , setNotificationQRPopup ] = useAtom ( notificationQRPopupAtom );

	const router = useRouter ();

	const fetchMoreData = () => {
		setSize ( size + 1 );
	};

	useEffect ( () => {
		mutate ();
	}, [] );

	const redirectToExternalLink = page => {
		let href = page;

		var a = document.createElement ( "a" );

		a.href = href;
		a.setAttribute ( "target", "_blank" );
		a.click ();
	};

	const handleNotificationClick = ( { data } ) => {

		const screenType = pageName ( data.payload.screenName );

		mutate ( prev => {
			return prev.map ( itemArr => {
				return itemArr?.map ( item => {

					if ( item.SK === data?.SK ) {
						item.viewed = 1;
					}

					return item;
				} );
			} );
		} );

		clickImpression ( data ); // send notification read to backend

		if ( data?.payload?.CTA === "View" ) {
			redirectToExternalLink ( data?.payload?.externalLink );

			return;
		}

		if ( !screenType )
			return setNotificationQRPopup ( true );

		if ( screenType === "HOME" ) {
			router.push ( "/" );
		} else {
			setNotificationQRPopup ( true );

			return;
		}
	};

	const handleNotificationImpression = data => {
		if ( data?.viewed === 1 )
			return;

		viewImpression ( data );
	};

	const pageName = screenName => {

		switch ( screenName ) {
			// case "BROADCAST":
			// return "stream";

			// case "FEED":
			// return "video";

			// case "REELS":
			// return "video";

			// case "USER_PROFILE":
			// return "profile";

			case "HOME":
				return "HOME";

			case "CONTEST_LIST":
				return null;

			case "CONTEST":
				return null;

			default:
				return null;
		}
	};

	if ( error ) {
		return null;
	}

	return (
		<Presentation
			activeTab                    = { activeTab }
			activeUpdateTab              = { activeUpdateTab }
			feedData                     = { feedData }
			fetchMoreData                = { fetchMoreData }
			handleNotificationClick      = { handleNotificationClick }
			handleNotificationImpression = { handleNotificationImpression }
			isDataEmpty                  = { isDataEmpty }
			isDepleted                   = { isDataEmpty }
			isFetching                   = { isLoadingMoreData }
		/>
	);
};

export default component;
